import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { CybersocXDRDashboardSearchCriteria } from '../../shared/model/searchCriteria';
import { CybersocxdrglobalfiltersService } from '../cybersocxdrglobalfilters.service';
import { XtendedChartService } from 'src/app/shared/services/xtendedsoc/xtended-chart.service';
import { Fields4A3W } from 'src/app/shared/model/cybersocxdr/charts/4A3W';
import { repartitionChartItemToHighchartsSeries } from '../charts/mappers/pie.mapper';

interface DrillDownSerie {
  id: string;
  name: string;
  data: [string, number][];
}

@Component({
  selector: 'app-xtendedsoc4A3W',
  templateUrl: './xtendedsoc4A3W.component.html',
  styleUrls: ['./xtendedsoc4A3W.component.scss'],
})
export class XtendedSOC4A3WComponent implements OnInit {
  @Output() searchEmitter = new EventEmitter<CybersocXDRDashboardSearchCriteria>(true);

  constructor(
    private globalFilters: CybersocxdrglobalfiltersService,
    private xtendedChartService: XtendedChartService
  ) {}

  //Data
  selected4AGroupBy: Fields4A3W = Fields4A3W.ACTION;
  selected3WGroupBy: Fields4A3W = Fields4A3W.WHO;

  grouped4AIncidents: Highcharts.SeriesPieOptions[];
  grouped4AIncidentsDrilldown: DrillDownSerie[];

  grouped3WIncidents: Highcharts.SeriesPieOptions[];
  grouped3WIncidentsDrilldown: DrillDownSerie[];

  sankeySeries: Highcharts.SeriesSankeyOptions[];

  groupBy4AOptions = [
    { value: Fields4A3W.ACTOR, translateKey: 'pages.cybersocxdr.4A3W.actor' },
    { value: Fields4A3W.ACTION, translateKey: 'pages.cybersocxdr.4A3W.action' },
    { value: Fields4A3W.ASSET, translateKey: 'pages.cybersocxdr.4A3W.asset' },
    { value: Fields4A3W.ATTRIBUTE, translateKey: 'pages.cybersocxdr.4A3W.attribute' },
  ];

  groupBy3WOptions = [
    { value: Fields4A3W.WHAT, translateKey: 'pages.cybersocxdr.4A3W.what' },
    { value: Fields4A3W.WHO, translateKey: 'pages.cybersocxdr.4A3W.who' },
    { value: Fields4A3W.WHY, translateKey: 'pages.cybersocxdr.4A3W.why' },
  ];

  onSelectGroupBy4A(value: Fields4A3W) {
    this.selected4AGroupBy = value;
    this.search4A();
  }

  onSelectGroupBy3W(value: Fields4A3W) {
    this.selected3WGroupBy = value;
    this.search3W();
  }

  ngOnInit(): void {
    this.search4A();
  }

  async search() {
    this.search4A();
    this.search3W();
    this.searchSankey();
  }

  async search4A() {
    const searchCriteria = this.globalFilters.searchCriteria;
    const data = await this.xtendedChartService.get4A3WByField(searchCriteria, this.selected4AGroupBy);
    this.grouped4AIncidents = [
      {
        name: this.selected4AGroupBy,
        type: 'pie',
        data: data.map(repartitionChartItemToHighchartsSeries),
      },
    ];
    this.grouped4AIncidentsDrilldown = data
      .filter((d) => d.detail)
      .map((d) => {
        return { name: d.name, id: d.name, data: d.detail.map((x) => [x.name, x.volume]) };
      });
  }

  async search3W() {
    const searchCriteria = this.globalFilters.searchCriteria;
    const data = await this.xtendedChartService.get4A3WByField(searchCriteria, this.selected3WGroupBy);
    this.grouped3WIncidents = [
      {
        name: this.selected3WGroupBy,
        type: 'pie',
        data: data.map(repartitionChartItemToHighchartsSeries),
      },
    ];
    this.grouped3WIncidentsDrilldown = data
      .filter((d) => d.detail)
      .map((d) => {
        return { name: d.name, id: d.name, data: d.detail.map((x) => [x.name, x.volume]) };
      });
  }

  async searchSankey() {
    const searchCriteria = this.globalFilters.searchCriteria;
    const [nodes, nodesLinks] = await this.xtendedChartService.get4A3WSankey(searchCriteria);

    this.sankeySeries = [
      {
        keys: ['from', 'to', 'weight'],
        nodes: nodes.map((n) => ({ id: n })),
        data: nodesLinks,
        type: 'sankey',
      },
    ];
  }
}
